export const profile = {
  extends: 'ContentPage',
  metadata: (el, s) => {
    const person = el.call('findMe', s)
    const name = person?.name || 'Profile'
    return { title: name + ' / People / Symbols Workspace' }
  },
  eyebrow: 'Account',
  title: 'Profile',
  sections: (el, s) => {
    const person = el.call('findMe', s)
    const sections = [{ label: 'Profile' }, { label: 'Availability' }]
    if (el.call('canAccessPrivate', person)) {
      sections.push(
        { label: 'Equity grant' },
        { label: 'Documents' },
        { label: 'Checklist' }
      )
    }
    if (el.call('isSelf')) {
      sections.push(
        { label: 'Security' },
        { label: 'Notifications' },
        { label: 'Sessions' },
        { label: 'Danger zone' }
      )
    }
    return sections
  },

  PageBody: {
    flow: 'y',
    gap: 'D',
    flex: '1',
    minWidth: '0',
    MemberProfile: {}
  }
}
